
<template>

  <svg viewBox="0 0 29 48" aria-hidden="true">

    <path d="m12 10-1.09-10h-1.09l-0.77 10h-1.6l-0.9-10h-1.1l-0.9 10h-1.6l-0.77-10h-1.09l-1.09 10c0 5 1.1 7 4.1 9 0 12.69-2.1 22.33-2.1 24.64s2 4.36 4 4.36 4-2.05 4-4.36-2.1-11.95-2.1-24.64c3-2 4.1-4 4.1-9"

      fill="currentColor" />

    <path d="m28 2c0-1.48-1-2-2-2s-2.83 0.88-4 3c-1.69 3.07-2 11.83-2 21 2.19 0.59 3.1 2.46 3.1 4 0 10.99-2.1 13.37-2.1 15.67s2 4.33 4 4.33 4-2.07 4-4.37-1-4.69-1-15.63z"
    
      fill="currentColor" />

  </svg>

</template>
